import type { Destination as CaptureDestination } from './destination';

export type DestinationAnalyticsProperties =
  | { readonly destination_type: 'workspace' }
  | { readonly destination_type: 'collection'; readonly collection_id: string }
  | { readonly destination_type: 'note'; readonly destination_note_id: string };

export function destinationAnalyticsProperties(
  destination: CaptureDestination,
): DestinationAnalyticsProperties {
  switch (destination.type) {
    case 'workspace':
      return { destination_type: 'workspace' };
    case 'project':
      return { destination_type: 'collection', collection_id: destination.id };
    case 'note':
      return { destination_type: 'note', destination_note_id: destination.id };
  }
}

export function destinationIcon(destination: CaptureDestination): string {
  if (destination.type === 'workspace') return 'home';
  if (destination.type === 'project') return 'folder';
  return 'description';
}

export function destinationLabel(destination: CaptureDestination): string {
  if (destination.type === 'workspace') return 'Workspace';
  if (destination.type === 'project') return 'Collection';
  return 'Note';
}

export function destinationSearchCopy(showNotes: boolean) {
  return showNotes
    ? { ariaLabel: 'Search collections or notes', placeholder: 'Search collections or notes…' }
    : { ariaLabel: 'Search collections', placeholder: 'Search collections…' };
}
